export const COW_ENTERED = "COW_ENTERED";
export const COW_EXIT = "COW_EXIT";
export const RESET_ASTRONAUT_STATE = "RESET_ASTRONAUT_STATE";
